import * as React from "react";
import {DeprecatedIconButton} from "@octopusdeploy/design-system-components";

interface CloseButtonProps {
    onClose?: () => void;
    tooltip?: string;
    size?: string;
}

const CloseButton: React.FC<CloseButtonProps> = (props) => {
    const wrapperStyle: React.CSSProperties = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "middle",
    };
    if (props.size) {
        wrapperStyle.width = props.size;
        wrapperStyle.height = props.size;
    }

    return (
        <span style={wrapperStyle}>
            <DeprecatedIconButton
                icon="XmarkIcon"
                onClick={() => props.onClose?.()}
                accessibleName={props.tooltip || "Close"}
            />
        </span>
    );
};

CloseButton.displayName = "CloseButton";

export default CloseButton;
